export enum EDietComponentType {
	SEMIPRODUCT = 'dietary_semi_product',
	MATERIAL = 'dietary_raw_material',
}
